import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';

import TooltipContentWrapper from '@common/components/tooltip_container/tooltip_content_wrapper';
import { addFlyout, FLYOUT_TYPES } from '@common/utils/flyout';
import DefaultSkeleton from '../../skeletons/default_skeleton';

import './gap_days_cell.scss';

const CLASS_NAME = 'gap-days-cell';

const START_DATE_FORMAT = 'YYYY-MM-DD';
const START_DATE_FINAL_FORMAT = 'MMM D';

const formatDate = date => date && moment(date, START_DATE_FORMAT).format(START_DATE_FINAL_FORMAT);
const isNotEmpty = data => !_.isEmpty(_.keys(data));

const onReservationClick = reservationId => () => {
  addFlyout(FLYOUT_TYPES.RESERVATION_DETAILS, {
    reservationId,
  });
};

const checkinCheckoutSetup = (checkin, checkout) => {
  const type = {};

  if (isNotEmpty(checkin) && !isNotEmpty(checkout)) {
    const checkinDate = _.get(checkin, 'checkin_date');
    type.id = _.get(checkin, 'id');
    type.subtitle = `Check-in ${checkinDate ? formatDate(checkinDate) : ''}`;
    type.title = _.get(checkin, 'type_guest.name');
  } else if (isNotEmpty(checkin) && isNotEmpty(checkout)) {
    const checkoutDate = _.get(checkin, 'checkout_date');
    type.id = _.get(checkout, 'id');
    type.subtitle = `Back to Back ${checkoutDate ? formatDate(checkoutDate) : ''}`;
    type.title = _.get(checkin, 'type_guest.name');
  }

  return type;
};

const GapDaysCell = (props, customProps) => {
  const events = _.get(props, 'events');
  const gapDays = _.get(props, 'events.gap');
  const checkin = _.get(props, 'events.checkin');
  const checkout = _.get(props, 'events.checkout');

  const containerHeight = _.get(customProps, 'containerHeight', window.innerHeight);
  const containerWidth = _.get(customProps, 'containerWidth', window.outerWidth);
  const defaultCell = _.get(customProps, 'defaultCell');
  const withArrow = _.get(customProps, 'withArrow');
  const withLink = _.get(customProps, 'withLink');
  const withSkeletons = _.get(customProps, 'withSkeletons');
  const withTooltip = _.get(customProps, 'withTooltip');

  if (withSkeletons && _.isUndefined(events) && _.isUndefined(gapDays)) {
    return <DefaultSkeleton />;
  }

  if (_.isEmpty(_.keys(events)) || _.isNull(gapDays)) {
    return <div className="default-cell--empty"> - </div>;
  }

  const content = <div className={`${CLASS_NAME}__title`}>{gapDays}</div>;

  const { title, subtitle, id } = checkinCheckoutSetup(checkin, checkout);
  const tooltipContent = (
    <div className={`${CLASS_NAME}__tooltip`}>
      <div className={`${CLASS_NAME}__tooltip-title`}>{title}</div>
      <div className={`${CLASS_NAME}__tooltip-sub-title`}>{subtitle}</div>
    </div>
  );

  return (
    <TooltipContentWrapper
      className={`${CLASS_NAME}__wrapper`}
      containerHeight={containerHeight}
      containerWidth={containerWidth}
      content={content}
      defaultCell={defaultCell}
      onClick={onReservationClick(id)}
      tooltipContent={tooltipContent}
      withArrow={withArrow}
      withLink={withLink}
      withTooltip={withTooltip}
    />
  );
};

GapDaysCell.propTypes = {
  next_reservation: PropTypes.shape({
    checkin_date: PropTypes.string,
    checkin_time: PropTypes.string,
    gap: PropTypes.number,
    id: PropTypes.number,
  }),
};

export default GapDaysCell;
